import { Map } from 'immutable';
import core from './core';

const INITIAL_STATE = new Map({
    list: new Map(),
    initialized: false
});

export default function SDM17SPG(state = INITIAL_STATE, action) {
    switch (action.type) {
        case 'MYFHE__FHEPRODUCT_SET_SDM17SPGS':
            return core.setSDM17SPGs(state, action.SDM17SPGs);
        case 'MYFHE__FHEPRODUCT_UPDATE_SDM17SPGS':
            return core.updateSDM17SPGs(state, action.SDM17SPGs);
        case 'MYFHE__FHEPRODUCT_SET_SDM17SPG_DETAILS':
            return core.setSDM17SPGDetails(state, action.SDM17SPGId, action.SDM17SPGDetails);
        case 'MYFHE__FHEPRODUCT_UPDATE_SDM17SPG_STATUS':
            return core.updateSDM17SPGStatus(state, action.productIdentifier, action.status);
        case 'MYFHE__FHEPRODUCT_MASTER_SWITCH_SDM17SPG':
            return core.switchSDM17SPGMaster(state, action.productIdentifier, action.masterId);
        case 'MYFHE__FHEPRODUCT_DISSOCIATE_USER_SDM17SPG':
            return core.dissociateUserFromSDM17SPG(state, action.productIdentifier, action.userId);
        case 'MYFHE__FHEPRODUCT_DISSOCIATE_USER_AND_SWITCH_MASTER_SDM17SPG':
            return core.dissociateUserFromSDM17SPGAndSwitchMaster(state, action.productIdentifier, action.userId, action.masterId);
    }

    return state;
}



// WEBPACK FOOTER //
// ./environments/myfhe/data/SDM17SPG/reducer.js